import './index.css';
import App from './App';
import React, { useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { auth } from './services/firebase';
import { getStoredTheme, applyTheme } from './services/theme';

// Apply the saved theme before first render to avoid a flash of the wrong theme.
applyTheme(getStoredTheme());

function AuthInitializer() {
  const [initializing, setInitializing] = useState(true);

  useEffect(() => {
    // Wait for auth to initialize
    const unsubscribe = auth.onAuthStateChanged(() => {
      console.log("Auth state initialized in AuthInitializer");
      setInitializing(false);
    });
    
    return () => unsubscribe();
  }, []);

  if (initializing) {
    return <div>Loading...</div>;
  }
  return <App />;
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <AuthInitializer />
  </React.StrictMode>
);
